// Not used on web platforms, only with downloads on native mobile
export const ActionSheet = () => null
